import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/response/auth.models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUserProfile: BehaviorSubject<any>;
    public currentUser: Observable<User>;
    public apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUserProfile = new BehaviorSubject<any>(JSON.parse(sessionStorage.getItem('currentUserProfile')));

        // this.currentUserSubject = new BehaviorSubject<User>(this.localService.getJsonValue('currentUser') ? JSON.parse(this.localService.getJsonValue('currentUser')) : '');
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'mirlAppToken': environment.mirlAppToken
        }),
    };


    login(data: User[]) {
        return this.http.post<any>(`${this.apiUrl}/admin/login`, data, this.httpOptions)
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user) {
                    var profile = user.data.profile;

                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    sessionStorage.setItem('currentUserProfile', JSON.stringify(user.data.profile));
                    this.currentUserSubject.next(user);
                    this.currentUserProfile.next(profile);
                }
                return user;
            }));
    }

    reset(data: any) {
        return this.http.post<any>(`${this.apiUrl}/admin/forgot-password`, data, this.httpOptions)
            .pipe(map(user => {
                this.currentUserSubject.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUserProfile');
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('loginUser');
        this.currentUserSubject.next(null);
        this.currentUserProfile.next(null);

    }
}
